import React, { Component } from 'react'
import PropTypes from 'prop-types'
// import Swiper from 'swiper'
import Swiper from 'swiper/dist/js/swiper.js'
import cx from 'classnames'

// import './Swiper.scss'

export default class ReactSwiper extends Component {

  state = { activeIndex: 0 }

  componentDidMount () {
    this.initSwiper()
  }

  initSwiper () {
    if (!this.containerNode) {
      return false
    }
    this.swiper = Swiper(this.containerNode, {
      ...this.props,
      initialSlide: this.state.activeIndex
    })
  }

  componentWillReceiveProps (nextProps) {
    let slide = nextProps.slide

    if (slide != null && slide !== this.state.activeIndex) {
      this.setState({ activeIndex: slide }, () => this.swiper.slideTo(slide))
    }

    this.swiper.update()
  }

  shouldComponentUpdate (nextProps) {
    if (nextProps.children !== this.props.children) {
      return true
    }
    if (nextProps.slide !== this.state.activeIndex) {
      return true
    }
    return false
  }

  componentDidUpdate () {
    if (this.props.rebuildOnUpdate) {
      this.swiper.destroy(true, true)
      this.initSwiper()
    } else {
      this.swiper.update()
    }
  }

  componentWillUnmount () {
    this.swiper.destroy(true, true)
    delete this.swiper
  }

  handleInit = (swiper) => {
    this.setState({ activeIndex: swiper.activeIndex })
    this.props.onInit(swiper)
  }

  handleTransitionEnd = (swiper) => {
    this.setState({ activeIndex: swiper.activeIndex })
    this.props.onTransitionEnd(swiper)
  }

  render () {
    return (
      <div
        className={cx(this.props.containerClass, this.props.classNames)}
        ref={ref => (this.containerNode = ref)}
      >
        <div className={this.props.wrapperClass}>
          {this.props.children.map(
            e => React.cloneElement(e, {
              className: cx(this.props.slideClass, e.props.className, this.props.noSwiping && 'swiper-no-swiping')
            })
          )}
        </div>
      </div>
    )
  }

  static defaultProps = {
    classNames: [],
    containerClass: 'swiper-container',
    wrapperClass: 'swiper-wrapper',
    slideClass: 'swiper-slide',
    rebuildOnUpdate: false,
    onTransitionEnd: () => null,
    onInit: () => null,
    children: []
  }

  static propTypes = {
    classNames: PropTypes.array,
    containerClass: PropTypes.string,
    wrapperClass: PropTypes.string,
    slideClass: PropTypes.string,
    rebuildOnUpdate: PropTypes.bool,
    onTransitionEnd: PropTypes.func,
    onInit: PropTypes.func,
    noSwiping: PropTypes.bool,
    children: PropTypes.array,
    // TODO: remove this comment when this is fixed:
    // https://github.com/yannickcr/eslint-plugin-react/issues/1142
    // eslint-disable-next-line react/no-unused-prop-types
    slide: PropTypes.number,
  }
}



// WEBPACK FOOTER //
// ./src/templates/insta/components/Swiper.js